import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import WorkOrderStore from 'stores/WorkOrderStore';

const { Option } = Select;

function SelectVMRS({ value, onChange }) {
  const [codes, setCodes] = useState([]);

  // Fetch VMRS codes on mount
  useEffect(() => {
    async function fetchVMRSSysCodes() {
      const data = await WorkOrderStore.getVMRSSysCodes();
      setCodes(data);
    }
    fetchVMRSSysCodes();
  }, []);

  const options = codes.map((item) => (
    <Option key={item.sys} value={String(item.sys).padStart(3, '0')}>
      {String(item.sys).padStart(3, '0')} - {item.description}
    </Option>
  ));

  return (
    <Select
      style={{ width: '100%' }}
      showSearch
      mode="multiple"
      value={value}
      onChange={(value) => {
        if (onChange) {
          onChange(value);
        }
      }}
    >
      {options}
    </Select>
  );
}

export default SelectVMRS;
